export default class Locale_AadGroupPicker {
	SuggestedGroup: string = "Suggested Groups";
	NoResultsFound: string = "No results found"
	AadGroupPickerSuggestionsAvailable: string = "AAD Group Picker Suggestions available"
	Suggested: string = "Suggested groups";
}